
/**
 * 
 * The helper test passed. I’m doing a quick error check on the touched files so the new import and conditional onClick are clean in the editor as well.

Checked layoutElementVisibility.js, Navbar.js, layoutElementVisibility.test.js, no problems found

You control that in layoutElementVisibility.js now.

I added a separate click-control bucket:

So if you want the navbar logo to stay visible but not navigate on some URL, add a rule there, for example:

Or for a whole section:

The navbar reads that in Navbar.js. When the rule matches, the logo keeps rendering, but its onClick is removed and the pointer cursor is also removed, so it no longer sends the user to /.

I validated it with layoutElementVisibility.test.js. If you want, I can now add the exact URLs you have in mind.

 */
const hiddenLayoutElements = {
  navbarTop: [],
  navbarLogo: [],
  navbarLinks: [{ matchType: 'prefix', value: '/lp' }],
  navbarLanguage: [{ matchType: 'prefix', value: '/lp' }],
  navbarSupportPhone: [{ matchType: 'prefix', value: '/lp' }],
  navbarAuthButtons: [{ matchType: 'prefix', value: '/lp' }],
  footerUpperLogo: [],
  footerDescription: [],
  footerAppBadges: [],
  footerQuickLinks: [{ matchType: 'prefix', value: '/lp' }],
  footerInfoLinks: [],
  footerAddress: [{ matchType: 'prefix', value: '/lp' }],
  footerSocialLinks: [{ matchType: 'prefix', value: '/lp' }],
}

const disabledLayoutElementClicks = {
  navbarLogo: [{ matchType: 'prefix', value: '/lp' }],
  footerUpperLogo: [{ matchType: 'prefix', value: '/lp' }],
}

const normalizeLayoutPath = (path = '/') => {
  const [pathname] = String(path).split(/[?#]/)
  const trimmedPath = pathname.trim() || '/'
  const withLeadingSlash = trimmedPath.startsWith('/')
    ? trimmedPath
    : `/${trimmedPath}`

  if (withLeadingSlash === '/') {
    return '/'
  }

  return withLeadingSlash.replace(/\/+$/, '')
}

const routeRuleMatches = (path, rule) => {
  const normalizedPath = normalizeLayoutPath(path)
  const normalizedRuleValue = normalizeLayoutPath(rule.value)

  if (rule.matchType === 'exact') {
    return normalizedPath === normalizedRuleValue
  }

  if (rule.matchType === 'prefix') {
    return (
      normalizedPath === normalizedRuleValue ||
      normalizedPath.startsWith(`${normalizedRuleValue}/`)
    )
  }

  return false
}

const shouldHideLayoutElement = (elementKey, path) => {
  const rules = hiddenLayoutElements[elementKey] || []

  return rules.some((rule) => routeRuleMatches(path, rule))
}

const shouldDisableLayoutElementClick = (elementKey, path) => {
  const rules = disabledLayoutElementClicks[elementKey] || []

  return rules.some((rule) => routeRuleMatches(path, rule))
}

module.exports = {
  hiddenLayoutElements,
  disabledLayoutElementClicks,
  normalizeLayoutPath,
  shouldHideLayoutElement,
  shouldDisableLayoutElementClick,
}